import React, { type ReactNode } from 'react';

import { MenuItem } from '../../../common/ui/chat-header-menu/menu-item';

/** Known keys for more-menu sub-menus. Add new keys here when adding sub-menus. */
export type MoreMenuSubMenuKey = 'mobile-app';

export interface MoreMenuSubMenuItem {
	key: MoreMenuSubMenuKey;
	label: string;
	icon: ReactNode;
	title: string;
	content: ReactNode;
	testId?: string;
	onOpen?: () => void;
}

export interface RovoMobileQrSubMenuItemsProps {
	subMenuItems: MoreMenuSubMenuItem[];
	onOpenSubMenu: (key: string) => void;
}

export function RovoMobileQrSubMenuItems({
	subMenuItems,
	onOpenSubMenu,
}: RovoMobileQrSubMenuItemsProps): React.ReactNode[] {
	return subMenuItems.map((entry) => (
		<MenuItem
			key={entry.key}
			testId={entry.testId ?? `rovo-chat-header-${entry.key}-button`}
			label={entry.label}
			icon={entry.icon}
			onClick={() => {
				entry.onOpen?.();
				onOpenSubMenu(entry.key);
			}}
			isSubMenu
		/>
	));
}
